import { useQuery } from "@tanstack/react-query"
import { getEmailsForDeal } from "@/api"
import { DealEmail } from "@/types"

export const useDealEmails = (dealId?: number) => {
  const query = useQuery<{ emails: DealEmail[]; microsoftConnected: boolean }>({
    queryKey: ["dealEmails", dealId],
    queryFn: () => getEmailsForDeal(dealId!),
    staleTime: 1000 * 60 * 2,
    enabled: !!dealId,
    refetchOnWindowFocus: false,
  })

  return {
    emails: query.data?.emails ?? [],
    microsoftConnected: query.data?.microsoftConnected ?? null,
    isLoading: query.isLoading,
    error: query.error,
    refetch: query.refetch,
  }
}
